import React, {useEffect} from 'react';
import * as actions from '../actions';

export function DashboardOperationsJobs() {

	// useEffect(() => { actions.setHeader({
	// 	key: 'dashboardOperationsHeader',
	// 	component: (
	// 		<header><ul className="menu"><li><a className="button on" href="dashboardOperationsJobs"><span><span className="statusDot"></span>Jobs</span></a></li><li><a className="button" href="dashboardOperationsCalendar"><span>Calendar</span></a></li><li><a className="button" href="dashboardOperationsPersonnel"><span>Personnel</span></a></li></ul></header>
	// 	)
	// });

	// return () => {
	// 	actions.deleteHeader({ key: 'dashboardOperationsHeader'});
	// }
	// }, []);

	return <div className='dashboard operations'>

		<div className='searchForm'>
			<button className='icon iconLabel iconRight searchParameter'><span>Relay No.</span></button>
			<input type='search' placeholder='Search' autoCapitalize='none' autoCorrect='off' value='' />
			<button className='icon search disabled'><span>&nbsp;</span></button>
		</div>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span>DELIVERY <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<section className='expander expanded'>
					<header><button tabIndex={1}><span>UNSCHEDULED <span className='subtitle'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className=''>
						<div className='inner'>
							<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='date sorted'>Order Date</td>
										<td className='relayNumberAccountingId'>Legacy ID</td>
										<td className='name'>Client</td>
										<td className='address'>Address</td>
										<td className='name'>Delivery by</td>
										<td className='deliveryDate'>Delivery Date</td>
										<td className='builderJobReference'>Builder Job No.</td>
										<td className='count'></td>
										<td className='count'></td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody> 
									<tr>
										<td></td>
										<td className='date'>12/29/2022</td>
										<td className='relayNumberAccountingId'>000000.00</td>
										<td className='name'>Bill Bowers</td>
										<td className='address'>15, Billcrest Ave</td>
										<td className='name'>–</td>
										<td className='deliveryDate'>–</td>
										<td className='builderJobReference'>25645</td>
										<td className='count'></td>
										<td className='count'></td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
				<section className='expander collapsed'>
					<header><button tabIndex={ -1 }><span>SCHEDULED <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className=''>
						<div className='inner'>
							table here
						</div>
					</div>
				</section>
			</div>
		</section>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span>INSTALL <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<section className='expander expanded'>
					<header><button tabIndex={1}><span>UNASSIGNED <span className='subtitle'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className=''>
						<div className='inner'>
							<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='date sorted'>Order Date</td>
										<td className='relayNumberAccountingId'>Legacy ID</td>
										<td className='name'>Client</td>
										<td className='address'>Address</td>
										<td className='name'>Installer</td>
										<td className='installStartDate'>Install Start Date</td>
										<td className='builderJobReference'>Builder Job No.</td>
										<td className='count'></td>
										<td className='count'></td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className='date'>12/29/2022</td>
										<td className='relayNumberAccountingId'>000000.00</td>
										<td className='name'>Bill Bowers</td>
										<td className='address'>15, Billcrest Ave</td>
										<td className='name'>N. Nickerson</td>
										<td className='installStartDate'>–</td>
										<td className='builderJobReference'>25645</td>
										<td className='count'></td>
										<td className='count'></td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
				<section className='expander collapsed'>
					<header><button tabIndex={ -1 }><span>ASSIGNED <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className=''>
						<div className='inner'>
							table here
						</div>
					</div>
				</section>
			</div>
		</section>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span>WAITING FOR INSPECTION <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<div className='inner'>
					<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
						<thead>
							<tr>
								<td></td>
								<td className='date sorted'>Order Date</td>
								<td className='relayNumberAccountingId'>Legacy ID</td>
								<td className='name'>Client</td>
								<td className='address'>Address</td>
								<td className='name'>Installer</td>
								<td className='installStartDate'>Install Start Date</td>
								<td className='builderJobReference'>Builder Job No.</td>
								<td className='name fieldSupervisor'>Field Supervisor</td>
								<td className='action navigate'></td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td></td>
								<td className='date'>11/25/2022</td>
								<td className='relayNumberAccountingId'>000000.00</td>
								<td className='name'>Dana Carver</td>
								<td className='address'>225 E. Windmere</td>
								<td className='name'>N. Nickerson</td>
								<td className='installStartDate'>01/25/2023</td>
								<td className='builderJobReference'>88789</td>
								<td className='name fieldSupervisor'>Bob Smith</td>
								<td className='action navigate'></td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span>SERVICE <span className="subtitle"><span className="statusDot"></span>5 New Issues</span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<div className='inner'>
					<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
						<thead>
							<tr>
								<td></td>
								<td className='date sorted'>Order Date</td>
								<td className='relayNumberAccountingId'>Legacy ID</td>
								<td className='name'>Client</td>
								<td className='address'>Address</td>
								<td className='name'>Installer</td>
								<td className='name'>Service Tech</td>
								<td className='count centered'>New Issues</td>
								<td className='count centered'>Order</td>
								<td className='count centered'>Schedule</td>
								<td className='action'></td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td></td>
								<td className='date'>10/22/2022</td>
								<td className='relayNumberAccountingId'>000000.00</td>
								<td className='name'>Carol Danvers</td>
								<td className='address'>624 S. Sagewood Dr</td>
								<td className='name'>N. Nickerson</td>
								<td className='name'>M. Davidson</td>
								<td className='count centered'><span className="statusDot"></span>1</td>
								<td className='count centered'>2</td>
								<td className='count centered'>1</td>
								<td className='action navigate'></td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
	</div>;
}